import { render, staticRenderFns } from "./DownlineRepAchPayment.vue?vue&type=template&id=518d1a82&"
import script from "./DownlineRepAchPayment.vue?vue&type=script&lang=js&"
export * from "./DownlineRepAchPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports